module.exports = __webpack_public_path__ + "img/map-sputnik__icon.7d006c06.svg";